import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
interface WideFormState {
    wideFormDrawerVisible: boolean;
    orderLineId?: number;
    productId?: number;
}

// Define the initial state using that type
const initialState: WideFormState = {
    wideFormDrawerVisible: false
}

export const wideFormSlice = createSlice({
    name: 'wideForm',
    initialState,
    reducers: {
        initWideFormOrderLine: (state, action: PayloadAction<number>) => {
            state.orderLineId = action.payload === -1 ? undefined : action.payload;
        },
        initWideFormProduct: (state, action: PayloadAction<number>) => {
            state.productId = action.payload === -1 ? undefined : action.payload;
        },
        toggleWideFormDrawer: (state, action: PayloadAction<boolean>) => {
            state.wideFormDrawerVisible = action.payload;
        }
    }
});

export const { initWideFormOrderLine, initWideFormProduct, toggleWideFormDrawer } = wideFormSlice.actions;

export default wideFormSlice.reducer;